import accountDropdownStories from "./AccountDropdown.stories";

const stories = { name: "Navigation", children: [accountDropdownStories] };

export default stories;
